import { render } from "./SvgItem.vue?vue&type=template&id=b32ea244"
import script from "./SvgItem.vue?vue&type=script&lang=js"
export * from "./SvgItem.vue?vue&type=script&lang=js"

import "./SvgItem.vue?vue&type=style&index=0&id=b32ea244&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__